import React from "react";
import { Outlet, useLocation, useMatch } from "react-router-dom";
import CollaboratorsLayout from "./CollaboratorsLayout";
import "./PersistentCollaboratorsLayout.css";

/**
 * PersistentCollaboratorsLayout - Twitter/Reddit Style Navigation
 * 
 * This layout ensures the collaborators list NEVER unmounts when navigating to profile details.
 * 
 * Architecture:
 * - CollaboratorsLayout is ALWAYS rendered at full size
 * - When viewing profile detail, collaborators are hidden via visibility:hidden
 * - Profile page renders on TOP via Outlet
 * - Scroll position is preserved because collaborators dimensions don't change
 * 
 * Routes handled:
 * - /collaborators (main page)
 * - /collaborators/profile/:userId (profile overlay)
 */
const PersistentCollaboratorsLayout = () => {
  const location = useLocation();
  
  // Check if we're viewing a profile from collaborators
  const isProfileOpen = location.pathname.includes("/collaborators/profile/");

  return (
    <div className="persistent-collab-layout">
      {/* Profile Detail renders FIRST (on top via z-index) */}
      {isProfileOpen && (
        <div className="persistent-collab-layout__detail">
          <Outlet />
        </div>
      )}
      
      {/* Collaborators Container - ALWAYS MOUNTED at full size */}
      {/* visibility:hidden when profile is open, but dimensions preserved */}
      <div
        className={`persistent-collab-layout__list ${
          isProfileOpen ? "persistent-collab-layout__list--hidden" : ""
        }`}
        aria-hidden={isProfileOpen}
      >
        <CollaboratorsLayout />
      </div>
    </div>
  );
};

export default PersistentCollaboratorsLayout;
